module.exports = __webpack_public_path__ + "img/Statue_Main_Blurry.png";